<template>
    <svg viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.46214 4.41162L5.91214 0.94177C6.02929 0.823946 6.02929 0.632896 5.91214 0.515072L5.48788 0.0883751C5.37073 -0.0294489 5.18078 -0.0294678 5.06361 0.0883751L2.25 2.91815L0.936394 1.59699C0.819244 1.47916 0.629288 1.47916 0.512119 1.59699L0.0878625 2.02368C-0.0292875 2.14151 -0.0292875 2.33256 0.0878625 2.45038L2.03786 4.4116C2.15503 4.52946 2.34497 4.52946 2.46214 4.41162Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: "CheckIcon",
};
</script>
